import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AccountAdjustmentService {
  constructor(private http: HttpUtilService) {}

  getDetails(contractNo: string): Observable<any> {
    const encodedContractNo = encodeURIComponent(`"${contractNo}"`);
    const url = `AccountAdjustmentService.asmx/GetDetails?contractNo=${encodedContractNo}`;
    return this.http.get(url);
  }

  update(payload: any): Observable<any> {
    return this.http.post("AccountAdjustmentService.asmx/Update", {
      model: payload,
    });
  }
}
